import React from 'react';
import { TouchableOpacity, View, Text, Image, StyleSheet } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import logo from 'shared/assets/images/logo.png';
import colors from 'shared/modules/common/constants/colors';

export default function () {
  const isBigScreen = useMediaQuery({ minWidth: 768 });

  if (!isBigScreen) {
    return null;
  }

  const openInNewTab = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <View style={styles.root}>
      <View
        style={[
          styles.row,
          { justifyContent: 'space-between', marginBottom: 16 },
        ]}
      >
        <View style={[styles.row, { flex: 1, flexWrap: 'wrap' }]}>
          <TouchableOpacity
            style={styles.link}
            onPress={() => openInNewTab('https://paidy.com')}
          >
            <Text style={styles.text}>Paidy公式サイト</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.link}
            onPress={() => openInNewTab('https://paidy.com/about')}
          >
            <Text style={styles.text}>運営会社</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.link}
            onPress={() => openInNewTab('https://paidy.com/news')}
          >
            <Text style={styles.text}>ニュース</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.link}
            onPress={() => openInNewTab('https://paidy.com/faq')}
          >
            <Text style={styles.text}>よくあるご質問</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.link}
            onPress={() => openInNewTab('https://terms.paidy.com')}
          >
            <Text style={styles.text}>利用規約・同意書一覧</Text>
          </TouchableOpacity>
        </View>
        <Image
          source={logo}
          style={{ width: 88, height: 32 }}
          resizeMode="contain"
        />
      </View>
      <View style={{ marginBottom: 16 }}>
        <Text style={styles.text}>&copy; Paidy Inc.</Text>
      </View>
      <View>
        <View style={styles.row}>
          <Text style={[styles.text, styles.heading]}>事業内容</Text>
          <Text style={styles.text}>
            個別信用購入あっせん業 / 貸金業 / 第二種金融商品取引業
          </Text>
        </View>
        <View style={styles.row}>
          <Text style={[styles.text, styles.heading]}>登録</Text>
          <Text style={styles.text}>
            個別信用購入あっせん業者 関東（個）第86号-1 / 貸金業者
            東京都知事（1）第31529号 / 金融商品取引業
            関東財務局長（金商）第2149号
          </Text>
        </View>
        <View style={styles.row}>
          <Text style={[styles.text, styles.heading]}>加盟団体</Text>
          <Text style={styles.text}>
            一般社団法人第二種金融商品取引業協会 / 日本貸金業協会 第005391号 /
            一般社団法人日本クレジット協会 /
            一般社団法人コンピュータソフトウェア協会
          </Text>
        </View>
        <View style={styles.row}>
          <Text style={[styles.text, styles.heading]}>
            加入指定信用情報機関
          </Text>
          <Text style={styles.text}>
            株式会社日本信用情報機構 / 株式会社シー・アイ・シー
          </Text>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    marginTop: 48,
    paddingTop: 32,
    paddingBottom: 24,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderColor: colors.greyLight,
    width: '100%',
  },
  link: {
    marginRight: 24,
  },
  text: {
    fontSize: 13,
    color: '#A1AAB0',
  },
  heading: {
    minWidth: 130,
    marginRight: 16,
  },
  row: {
    flexDirection: 'row',
  },
});
